import { Anchor, Box, Text, Tooltip } from '@mantine/core';
import { IconUsers } from '@tabler/icons-react';

const HeaderStatistic = ({
  stats,
  id,
  stat,
  link,
  statKey,
  title,
  percentageOfStat,
  percentageOfId,
  secondaryStat,
  currency,
  costStat,
  costCurrency,
  costPer = 1,
  showPercentageSign = false,
}) => {
  const statsValue = (stat, id, key = statKey) => {
    return ((stats[stat] || {})[id.toString()] || {})[key] || 0;
  };

  const formatOptions = currency
    ? { style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 2 }
    : { minimumFractionDigits: 0, maximumFractionDigits: 2 };

  let percentageStatAddon = '';
  if (percentageOfStat) {
    percentageStatAddon = (
      <>
        <Text span c="dimmed">
          |{' '}
          {((statsValue(stat, id) / statsValue(percentageOfStat, percentageOfId || id) || 0) * 100).toLocaleString(
            navigator.language,
            { minimumFractionDigits: 0, maximumFractionDigits: 1 }
          )}
          %
        </Text>
      </>
    );
  }

  if (secondaryStat) {
    percentageStatAddon = (
      <>
        <Text span c="dimmed">
          |{' '}
          {statsValue(secondaryStat, id).toLocaleString(navigator.language, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })}
        </Text>
      </>
    );
  }

  let costStatAddon;
  if (costStat && statsValue(costStat, id, 'value')) {
    costStatAddon = (
      <>
        <Text span c="dimmed">
          {(((statsValue(costStat, id, 'value') || 0) / statsValue(stat, id)) * costPer).toLocaleString(
            navigator.language,
            {
              style: 'currency',
              currency: costCurrency,
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            }
          )}{' '}
          /{' '}
          {costPer.toLocaleString(navigator.language, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })}{' '}
        </Text>
      </>
    );
  }
  let value = (
    <>
      {statsValue(stat, id).toLocaleString(navigator.language, formatOptions)} {percentageStatAddon}{' '}
      {showPercentageSign && '%'}
      {costStatAddon ? (
        <>
          <br />
          {costStatAddon}
        </>
      ) : null}
    </>
  );

  return (
    <Box ta="center">
      <Text size="sm" c="dimmed">
        {title}
      </Text>
      <Text>
        {value}{' '}
        {link ? (
          <Tooltip label="Click to create segment." position="right">
            <Anchor href={link}>
              <IconUsers size={14} />
            </Anchor>
          </Tooltip>
        ) : null}
      </Text>
    </Box>
  );
};

export default HeaderStatistic;
